import { Box } from '@mui/material';

import routes from '@/assets/constants/routes-no.ts';
import Page from '@/components/Page/index.ts';
import StaticPageLayout from '@/components/StaticPageLayout/index.ts';

export default function Terms() {
  return (
    <Page title="Julekalender vilkår">
      <StaticPageLayout
        title="Vilkår for Scooprs Julekalender 2025"
        breadcrumbsItems={[
          {
            text: 'Hjem',
            url: '/',
          },
          {
            text: 'Julekalender',
            url: routes.ADVENT_2025_COMPETITION,
          },
          {
            text: 'Vilkår for Scooprs Julekalender 2025',
            url: null,
          },
        ]}
        subtitle="Dato for siste versjon: 17.11.2025"
      >
        <Box
          sx={(theme) => ({
            '& h2': {
              marginBottom: theme.spacing(2),
              marginTop: theme.spacing(6),
            },
            '& h3': {
              marginBottom: theme.spacing(1),
              marginTop: theme.spacing(3),
            },
          })}
        >
          <h3>1 – Vilkår for Scooprs julekalender 2025</h3>
          <p>
            I desember 2025 avholder Scoopr AS («Scoopr») en julekalender, der deltakere har
            mulighet til å delta i konkurranse om å vinne innfrielse av rentebærende kredittkort- og
            forbruksgjeld. Disse vilkårene gjelder for deltakelse i julekalenderen.
          </p>

          <h3>1.1 – Krav for deltakelse</h3>
          <p>
            Julekalenderen er tilgjengelig for personer over 18 år, som har tilgang til BankID og
            som er bosatt i Norge. Deltakeren må ha rentebærende kredittkortgjeld over 1.000 kroner.
            Deltakere melder seg på julekalenderen ved å trykke «Søk og Delta», godkjenne disse
            vilkårene, og gi samtykke til at Scoopr henter ut informasjon fra Gjeldsregisteret.
          </p>
          <p>
            Det koster ingenting å delta i julekalenderen, men det er et krav om at deltakeren
            oppretter en «Min Scoopr»- bruker. Vilkårene for Min Scoopr finnes
            <a href="https://scoopr.no/brukervilkar-min-scoopr" target="_blank" rel="noreferrer">
              her
            </a>
            . Deltakeren kan når som helst avslutte sin brukerkonto etter at julekalenderen er
            avsluttet.
          </p>
          <p>
            Ansatte i Scoopr og deres ektefeller, samboere, foreldre, søsken eller barn kan ikke
            delta i julekalenderen. Deltakere som ikke oppfyller kravene, kan bli nektet lodd
            og/eller premie.
          </p>

          <h3>1.2 – Om premien</h3>
          <p>
            Premien som utloddes til dagens vinner består av innfrielse av deltakerens rentebærende
            kredittkortgjeld inntil 100 000 kroner. Premien er likevel aldri større enn vinnerens
            rentebærende kredittkortgjeld på registreringstidspunktet.
          </p>
          <p>
            Beløpet innfris direkte hos banken hvor kredittkortgjelden er registrert. Innfrielse
            skjer normalt i løpet av en uke etter trekning. Dersom det er registrert
            kredittkortgjeld hos flere banker velger Scoopr hvilken bank gjelden innfris hos. Det er
            ikke anledning til å få beløpet utbetalt i kontanter, eller i form av andre ytelser.
          </p>
          <p>
            Dersom deltaker velger å refinansiere sin kredittgjeld hos Scoopr innen trekningen, vil
            premien kunne benyttes til å nedbetale på det nye lånet.
          </p>
          <p>
            Den 24. desember vil vi innfri rentebærende kredittkort-og forbruksgjeld til dagens
            vinner, inntil 500 000 kroner.
          </p>

          <h3>1.3 – Vilkår for mottak av premie</h3>
          <p>
            Vinneren kontaktes på telefon og e-post. Vinneren må straks etter å ha blitt kontaktet
            oppgi og bekrefte betalingsopplysninger slik at den aktuelle gjelden kan innfris. Dersom
            dette ikke er gjort innen 5 dager, vil retten til premie kunne bortfalle.
          </p>
          <p>
            Vinnere er selv ansvarlig for å rapportere og håndtere eventuell gevinst til
            skattemyndighetene, samt overholdelse av andre lovpålagte krav i forbindelse med
            gevinsten.
          </p>

          <h3>1.4 – Varighet og trekning</h3>
          <p>
            Julekalenderen varer fra 1. desember 2025 til 24. desember 2025 («kalenderperioden») og
            det trekkes én vinner hver dag. For å være med i trekningen må deltakeren melde seg på
            innen midnatt dagen før den aktuelle trekningen.
          </p>
          <p>
            Vinneren trekkes tilfeldig ved at alle deltakere får tildelt et deltakernummer.
            Trekningen gjøres gjennom en «random number generator service».
          </p>

          <h3>1.5 – Ansvarlig arrangør og tredjeparter</h3>
          <p>Det er Scoopr som er arrangør av julekalenderen.</p>
          <p>
            Julekalenderen støttes eller sponses ikke av noen tredjepart. Det opplyses særskilt om
            at julekalenderen verken støttes eller sponses av Meta, TikTok eller Google, selv om
            markedsføring skulle foregå gjennom disse kanalene. Deltakere kan ikke rette noen krav
            mot slike tredjeparter i forbindelse med konkurransen.
          </p>

          <h3>1.6 – Personopplysninger</h3>
          <p>
            I forbindelse med deltakelse vil Scoopr behandle personopplysninger. Personopplysningene
            benyttes til å registrere «Min Scoopr»-bruker, kontrollere overholdelse av vilkår og
            utnevne og kontakte vinnere. Scoopr behandler også opplysninger fra Gjeldsregisteret.
            Samtykket kan trekkes tilbake når som helst på{' '}
            <a href="https://www.gjeldsregisteret.com/" target="_blank" rel="noreferrer">
              www.gjeldsregisteret.com
            </a>
            .
          </p>
          <p>
            I løpet av kalenderperioden kan Scoopr sende informasjon på e-post og SMS for å minne om
            julekalenderen og gi informasjon om trekning og vinnere. Vinnere vil aldri bli annonsert
            med fullt navn, med mindre vinneren har samtykket til dette.
          </p>
          <p>
            Dersom deltakeren har takket ja til å motta markedsføring fra Scoopr, vil det også
            sendes markedsføring til vedkommende maksimalt to ganger i året, også i etterkant av
            kalenderperioden.
          </p>
          <p>
            Opplysningene om deltakere lagres i perioden julekalenderen avholdes og i en viss
            periode etterpå for å kunne påvise at Scoopr har overholdt lovpålagte krav.
            Opplysningene registrert i Min Scoopr oppbevares frem til brukeren sletter sin profil.
          </p>
          <p>
            Opplysningene kan bli delt med andre selskaper i Scoopr-konsernet for formålene
            beskrevet over. Se mer informasjon i Scooprs personvernerklæring{' '}
            <a href="https://scoopr.no/personvernerklaering/" target="_blank" rel="noreferrer">
              her
            </a>
            .
          </p>

          <h3>1.7 – Avbryte</h3>
          <p>
            Dersom uforutsette hendelser skulle oppstå, som Scoopr ikke med rimelighet kunne forutse
            ved igangsetting av julekalenderen, forbeholder Scoopr seg retten til å avbryte
            konkurransen med fremtidig virkning. Scoopr vil utlodde premier til vinnere som allerede
            er trukket og så langt mulig varsle deltakere og gi deltakere mulighet for
            avregistrering og avslutning av Min Scoopr-brukeren.
          </p>

          <h3>1.8 – Henvendelser</h3>
          <p>
            Dersom deltakeren har spørsmål om disse vilkårene eller andre forhold kan Scoopr AS, med
            adresse Karenslyst Allé 2, 0278 Oslo, kontaktes på telefon{' '}
            <a href="tel:41800000">418 00 000</a> eller på e-post til{' '}
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>.
          </p>

          <br />
          <h4>Scoopr AS</h4>
          <h4>Scoopr Refinansiering AS</h4>
          <p>
            <a href="mailto:post@scoopr.no">post@scoopr.no</a>
          </p>
          <p>Karenslyst Allé 2</p>
          <p>0278 Oslo</p>
        </Box>
      </StaticPageLayout>
    </Page>
  );
}
